export default __webpack_public_path__ + "static/blog-1-cd85e9ad87e602719c02d074465c816a.jpg";